let productFeaturedSection = document.querySelectorAll('.custom-featured-product__section');
if( productFeaturedSection ){
    productFeaturedSection.forEach(function (section) {
        let quantityInput = section.querySelector('quantity-input input');
        let formVariant = section.querySelector('form input[name="id"]');
        let subscriptionInput = section.querySelector('.selling_plan_input');
        let selectorElements = section.querySelectorAll('.plan__selector-element');
        if(selectorElements){
            selectorElements.forEach(function (element) {
                element.addEventListener('click', function (event) {
                    selectorElements.forEach(function (element) {
                        element.classList.remove('active');
                    });
                    element.classList.add('active');
                    if(element.classList.contains('one-time')){
                        element.closest('.custom-subscription-widget').classList.remove('subscription')
                        element.closest('.custom-subscription-widget').classList.add('one-time')
                        quantityInput.value = 1;
                    } else if (element.classList.contains('subscription')){
                        element.closest('.custom-subscription-widget').classList.remove('one-time')
                        element.closest('.custom-subscription-widget').classList.add('subscription')
                        quantityInput.value = 1;
                    }
                    let activeInput = element.querySelector('[data-plan]')
                    if (activeInput){
                        subscriptionInput.value = element.querySelector('[data-plan]').getAttribute('data-plan');
                        formVariant.value = element.querySelector('[data-plan] option[selected]').getAttribute('data-variant');
                    } else {
                        subscriptionInput.value = '';
                        formVariant.value = this.getAttribute('data-variant-one-time');
                    }
                });
            });
        }

        section.querySelectorAll(".custom-select").forEach(select => {
            select.addEventListener("change", function () {
                select.setAttribute("data-plan", this.value);
                subscriptionInput.value = this.value;
                formVariant.value = this.options[this.selectedIndex].getAttribute('data-variant');
                let parent = this.closest('.plan__selector-element.subscription');
                parent.querySelector('.price__compare').innerHTML = this.options[this.selectedIndex].getAttribute('data-compare-price');
                parent.querySelector('.price').innerHTML = this.options[this.selectedIndex].getAttribute('data-price');
            });
        });
    });
}